<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">
                <i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <AddForm
        ref="addModal"
        :default-values="{}"
        @finish="handleItemsUpdate"
      />
      <AssignForm
          ref="assignModal"
          :default-values="{}"
          @finish="handleItemsUpdate"
      />
      <TomHornFreespinsImportForm ref="importModal" />
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <div class="col-lg-12">
            <b-button
              type="button"
              variant="success"
              class="mb-1 mr-1"
              @click="$refs.addModal.showModal()"
            >
              <i class="fas fa-plus"></i> Add issue
            </b-button>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div
            class="col-lg-3 col-md-3 col-sm-12"
            v-for="{
              id,
              type,
              label,
              options,
              loaded,
              internalSearch,
              searchChange
            } in filterInputs"
            v-bind:key="id"
          >
            <b-form-group
              label-cols-lg="4"
              :label-for="id + '-filter-input'"
              :label="label"
              v-if="type === 'input'"
            >
              <b-form-input
                :id="id + '-filter-input'"
                v-model="filters[id]"
                autocomplete="off"
                :placeholder="'Enter ' + label"
              />
            </b-form-group>

            <b-form-group
              label-cols-lg="4"
              :label-for="id + '-filter-input'"
              :label="label"
              v-if="type === 'multiselect'"
            >
              <multiselect
                v-model="filters[id]"
                :disabled="!loaded"
                :loading="!loaded"
                :options="options"
                label="label"
                track-by="value"
                :multiple="false"
                :placeholder="'Select ' + label"
                :internal-search="internalSearch"
                @search-change="searchChange"
              />
            </b-form-group>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons
              :cancel="this.cancel"
              :loadFn="loadItems"
              :cancelFn="cancelRequest"
              :resetFn="clearFilters"
            />
          </div>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                  striped
                  small
                  hover
                  show-empty
                  no-local-sorting
                  sort-icon-left
                  :busy="!!cancel"
                  :items="filteredItems"
                  :empty-text="emptyText"
                  :fields="fields"
                >
                  <template #cell(actions)="{item}">
                    <span>
                      <b-button
                        type="button"
                        variant="success"
                        class="mr-1 btn-xs"
                        @click="$refs.addModal.showModal(item)"
                      >
                        <i class="fas fa-copy"></i> Copy
                      </b-button>
                    </span>
                    <RemoveForm
                      :object="item.name"
                      message="Please confirm canceling issue"
                      :remove-handler="
                        modal => {
                          handleFreespinsRemove(modal, item);
                        }
                      "
                    ></RemoveForm>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.table td {
  min-width: 50px !important;
}
</style>
<script>
import axios from "axios";
import {getRouteIcon, ROUTE_BGAMING_FREESPINS} from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons";
import Multiselect from "vue-multiselect";
import RemoveForm from "../../components/TomHornFreespins/RemoveForm.vue";
import TomHornFreespinsImportForm from "../../components/TomHornFreespins/TomHornFreespinsImportForm.vue";
import TomHornFreespinsAssignForm from "../../components/TomHornFreespins/TomHornFreespinsAssignForm.vue";
import BGamingFreespinAddForm from "../../components/SoftSwissFreespins/BGamingFreespinsAddForm.vue";

function getDefaultSort() {
  return {
    column: "username",
    order: "ASC"
  };
}

function getDefaultFilters() {
  return {
    status: null
  };
}

export default {
  components: {
    TomHornFreespinsImportForm,
    AddForm: BGamingFreespinAddForm,
    AssignForm: TomHornFreespinsAssignForm,
    RemoveForm,
    FilterButtons,
    Multiselect
  },
  data() {
    return {
      filters: getDefaultFilters(),
      cancel: null,
      error: null,
      fields: [
        { key: "issueId", label: "Issue Id" },
        { key: "operatorName", label: "operator" },
        { key: "currency", label: "Currency" },
        { key: "game", label: "Game" },
        { key: "validUntil", label: "Valid until" },
        { key: "betLevel", label: "Bet level" },
        { key: "freespinsQuantity", label: "Freespins quantity" },
        { key: "userId", label: "User Id" },
        { key: "actions", label: "Actions" }
      ],
      items: [],
      sorts: getDefaultSort()
    };
  },
  computed: {
    filteredItems() {
      let items = this.items;
      if (this.filters.status && this.filters.status.value) {
        items = this.items.filter(
          item => item.state === this.filters.status.value
        );
      }
      return items;
    },
    filterInputs() {
      return [
        // {
        //   id: "status",
        //   type: "multiselect",
        //   label: "Status",
        //   options: [
        //     "Upcoming",
        //     "Completed",
        //     "Cancelled",
        //     "Running",
        //   ].map(item => {
        //     return { value: item, label: item };
        //   }),
        //   internalSearch: true,
        //   loaded: true,
        //   searchChange: () => {}
        // }
      ];
    },
    emptyText() {
      if (this.cancel) {
        return "Loading items..";
      }

      if (this.error?.response?.data?.message) {
        return this.error?.response?.data?.message;
      }

      if (this.error) {
        return this.error.message;
      }

      return "There are no records to show";
    },
    routeIcon: () => getRouteIcon(ROUTE_BGAMING_FREESPINS),
    playerIds() {
      return (this.filters.playerIds || "")
        .split(",")
        .map(playerId => playerId.trim())
        .filter(value => !!value);
    }
  },
  methods: {
    clearFilters() {
      this.filters = getDefaultFilters();
    },
    handleFreespinsRemove(modal, item) {
      this.$http({
        url: "/api/v1/softswiss/freespins/cancel",
        method: "POST",
        data: {
          issueId: item.issueId,
          token: item.token,
        },
        headers: { "Content-Type": "application/json" }
      })
        .then(() => {
          this.loadItems();
          modal.hideModal();
          this.$toastr.i("Success");
        })
        .catch(err => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
    handleItemsUpdate({ secret, playerIds }) {
      this.filters.secret = secret;
      this.filters.playerIds = playerIds;

      this.loadItems();
    },
    loadItems() {
      this.items = [];

      let self = this;

      this.$http({
        url: "/api/v1/softswiss/freespins",
        params: {
          ...this.filters,
        },
        method: "GET",
        cancelToken: new axios.CancelToken(c => {
          self.cancel = c;
        })
      })
        .then(resp => {
          let { items } = resp.data;
          this.items = items
            .sort((a, b) => (a.id < b.id ? 1 : -1))
            .map(item => {
              let count = item.type === "regular" ? item.count : null;
              return { ...item, count };
            });
        })
        .catch(err => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          this.cancel = null;
        });
    },
    csvToArray(strData, strDelimiter = ",") {
      let objPattern = new RegExp(
        "(\\" +
          strDelimiter +
          "|\\r?\\n|\\r|^)" +
          '(?:"([^"]*(?:""[^"]*)*)"|' +
          '([^"\\' +
          strDelimiter +
          "\\r\\n]*))",
        "gi"
      );

      let arrData = [[]];
      let arrMatches = objPattern.exec(strData);
      while (arrMatches) {
        let strMatchedDelimiter = arrMatches[1];
        if (strMatchedDelimiter.length && strMatchedDelimiter != strDelimiter) {
          arrData.push([]);
        }
        let strMatchedValue;

        if (arrMatches[2]) {
          strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
        } else {
          strMatchedValue = arrMatches[3];
        }

        arrData[arrData.length - 1].push(strMatchedValue);
        arrMatches = objPattern.exec(strData);
      }
      return arrData;
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel("this -> cancel previous request");
      }
    }
  },
  mounted() {
    this.loadItems();
  },
};
</script>
